import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';

export const TOKEN_NAME = 'token';

@Injectable()
export class AuthenticationService {
  private url = 'api/auth';
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  private helper = new JwtHelperService();
  private readonly JWT_TOKEN = 'JWT_TOKEN';
  private readonly USER_DATA = 'USER_DATA';
  private readonly COMPANY_INFO = 'COMPANY_INFO';
  constructor(private http: HttpClient) { }

  getToken(): string {
    return localStorage.getItem(TOKEN_NAME);
  }

  setToken(token: string): void {
    localStorage.setItem(TOKEN_NAME, token);
    var expires = 300; // default: 1h

    var date = new Date();
    let schedule:string =String( Math.round((date.setSeconds(date.getSeconds()+expires))/1000));


    localStorage.setItem(TOKEN_NAME+'_time', schedule);
  }

  isTokenExpired(token?: string): boolean {
    /*if (!token) {
      token = this.getToken();
    }
    if (!token) {
      return true;
    }
    return this.helper.isTokenExpired(token);*/
  /*  var date = new Date();
    let current:number  = Math.round(+date/1000);
    let stored_time:number = Number(localStorage.getItem('JWT_TOKEN_time'));
   // if (stored_time==undefined) { stored_time = 0; }
   console.log("Expired= "+ stored_time);
   console.log("current= "+ current);
    // Expired
    if (stored_time > current) {

        // Remove
        console.log("Hello");
        return false;

      //  console.log("Hello");

    } else {
      console.log("Hello1");
      return this.helper.isTokenExpired(token);
    } */
    return false;
  }

  login(user): Promise<void | string> {
    return this.http
      .post(`${this.url}/login`, JSON.stringify(user), {
        headers: this.headers
      })
      .toPromise()
      .then(res => { });
  }

  logout(): void {
    setTimeout(() => {
      localStorage.removeItem(this.JWT_TOKEN);
      localStorage.removeItem(this.USER_DATA);
      localStorage.removeItem(this.COMPANY_INFO);
      localStorage.removeItem(TOKEN_NAME);
      localStorage.removeItem('data');
      localStorage.removeItem('quotes');
      localStorage.removeItem('COMPANY_STORE');
    }, 400);
  }
}
